module.exports = __webpack_public_path__ + "images/health.c6651df46d244818f69d0601b9ca9df0.svg";